<div class="max-h-full overflow-y-auto scroll-smooth space-y-3 md:space-y-4">
  <div class="bg-white rounded-xl md:rounded-2xl shadow-lg p-3 sm:p-4 md:p-6 mx-auto">
    <div class="border-b border-blue-300 pb-2 mb-3 md:mb-4">
      <h1 class="text-base sm:text-lg md:text-xl font-semibold text-slate-900">1.1 New Study Creation</h1>
    </div>
    @if (currentStudy) {
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4">
      <div class="text-slate-700 text-xs sm:text-sm md:text-base break-words">
        Connected to study: <span class="font-semibold text-slate-900">{{ currentStudy }}</span>
      </div>
      <button
        class="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-semibold py-2.5 sm:py-2 md:py-3 px-3 sm:px-4 text-xs sm:text-sm md:text-base rounded-lg sm:rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 focus:outline-none cursor-pointer whitespace-nowrap"
        (click)="setRepo(null)">
        Disconnect Study
      </button>
    </div>
    } @else {
    <div class="tabs tabs-box w-full flex flex-col sm:flex-row">
      <input type="radio" name="my_tabs_3" class="tab flex-1 mb-2 sm:mb-0 sm:mr-2" aria-label="Cloud Studies"
        checked="checked" />
      <div class="tab-content p-3 sm:p-4 md:p-6 mt-2 rounded-xl md:rounded-2xl">
        <div class="space-y-2 max-w-5xl mx-auto">
          <div class="border border-blue-300 rounded-lg p-3 sm:p-4 md:p-6">
            <div class="flex items-center mb-3 md:mb-4">
              <span class="text-base sm:text-lg font-medium text-slate-800">➕ Create New Study</span>
            </div>
            <p class="text-sm sm:text-base text-gray-700 mb-3 md:mb-4">Start a new study in the cloud with automatic
              sync and backup</p>
            <div class="space-y-3 md:space-y-4">
              <div>
                <input #newStudy type="text" placeholder="Enter study ID or name" [(ngModel)]="newCloudRepoName"
                  class="w-full px-3 py-2 text-sm sm:text-base bg-white border border-slate-600 rounded-md focus:outline-none text-slate-800" />
              </div>
              <div class="flex justify-center">
                <button (click)="newRepo(newCloudRepoName, 'cloud', '')" [disabled]="!newCloudRepoName || selectStudy.value"
                  class="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-gray-400 disabled:transform-none text-white font-medium py-2 sm:py-3 px-4 text-sm sm:text-base rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer">
                  @if(isConnecting) {
                  <div class="flex items-center gap-2">
                    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    <span>Creating...</span>
                  </div>
                  } @else {
                  Create Study
                  }
                </button>
              </div>
              <!-- <div class="max-w-xl m-auto">
                @if(repoSelectionState?.type === 'cloud' && repoSelectionState?.state === 'repo_creation_failed'){
                <div class="flex flex-col items-center p-4 bg-red-500/10 rounded-xl border border-red-500/20">
                  <ng-icon name="phosphorXCircle" class="text-2xl text-red-500 mb-2"></ng-icon>
                  <p class="text-center font-medium mb-2 text-red-500">Unable to Create Study</p>
                  <p class="text-center text-gray-400 mb-4">We couldn't create your study. Please check your connection and
                    try again.</p>
                </div>
                }
              </div> -->
            </div>
          </div>

          <div class="text-center text-slate-400 text-sm sm:text-base">or</div>
          <div class="border border-blue-300 rounded-lg p-3 sm:p-4 md:p-6">
            <div class="flex items-center mb-3 md:mb-4">
              <span class="text-base sm:text-lg font-medium text-slate-800">🔗 Connect to Existing Study</span>
            </div>
            <p class="text-sm sm:text-base text-gray-600 mb-3 md:mb-4">Connect to an existing cloud study using its ID
              or name</p>

            <div class="space-y-3 md:space-y-4">
              <div>
                <p-select #selectStudy placeholder="Select study ID or name" [options]="cloudRepos" optionLabel="name"
                  class="w-full border border-slate-600 rounded-md focus:outline-none text-slate-300 text-sm sm:text-base" />
              </div>
              <div class="flex justify-center">
                <button (click)="connectCloudExistingRepo(selectStudy.value.name || '', selectStudy.value.id || '')" [disabled]="!selectStudy.value || newCloudRepoName"
                  class="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-gray-400 disabled:transform-none text-white font-medium py-2 sm:py-3 px-4 text-sm sm:text-base rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer">
                  @if(isCloudExistingConnecting) {
                  <div class="flex items-center gap-2">
                    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    <span>Connecting...</span>
                  </div>
                  } @else {
                  Connect to Study
                  }
                </button>
              </div>
              <div class="max-w-xl m-auto">
                @if(repoSelectionState?.type === 'cloud' && repoSelectionState?.state === 'repo_creation_failed'){
                <div class="flex flex-col items-center p-4 bg-red-500/10 rounded-xl border border-red-500/20">
                  <ng-icon name="phosphorXCircle" class="text-2xl text-red-500 mb-2"></ng-icon>
                  <p class="text-center font-medium mb-2 text-red-500">Unable to Create Study</p>
                  <p class="text-center text-gray-400 mb-4">We couldn't create your study. Please check your connection and
                    try again.</p>
                  <!-- <button class="btn btn-sm bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition-colors"
                    (click)="onClose()">Try Again</button> -->
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <input type="radio" name="my_tabs_3" class="tab flex-1 mb-2 sm:mb-0" aria-label="Local Studies" />
      <div class="tab-content p-3 sm:p-4 md:p-6 mt-2 rounded-xl md:rounded-2xl">
        <div class="space-y-4 sm:space-y-6 max-w-5xl mx-auto">
          <div class="border border-blue-300 rounded-lg p-3 sm:p-4 md:p-6">
            <div class="flex items-center mb-3 md:mb-4">
              <span class="text-base sm:text-lg font-medium text-slate-800">🔗 Connect to Local Study</span>
            </div>
            <p class="text-sm sm:text-base text-gray-600 mb-3 md:mb-4">Connect to a local study server</p>
            <div class="space-y-3 md:space-y-4">
              <div>
                <p class="block text-xs sm:text-sm font-medium text-slate-800 mb-2">Study URL</p>
                <input #urlInput type="text" placeholder="Enter study URL" [(ngModel)]="localUrl"
                  class="w-full px-3 py-2 text-sm sm:text-base bg-white border border-slate-600 rounded-md focus:outline-none text-slate-800" />
              </div>
              <div class="flex justify-center">
                <button (click)="localSubmitServerUrl(localUrl)" [disabled]="!localUrl"
                  class="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-gray-400 disabled:transform-none text-white font-medium py-2 sm:py-3 px-4 text-sm sm:text-base rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer">
                  Connect to Study
                </button>
              </div>
              <div class="max-w-xl m-auto">
                @if (repoSelectionState?.type === 'local' && repoSelectionState?.state === 'repo_does_not_exist'){
                <div class="flex flex-col items-center p-4 bg-gray-900/50 rounded-xl border border-gray-700">
                  <ng-icon name="phosphorPlusCircle" class="text-2xl text-white mb-2"></ng-icon>
                  <p class="text-center font-medium mb-2">Ready to Create New Study</p>
                  <p class="text-center text-gray-100 mb-4">Let's give your new study a name to get started</p>
                  <div class="flex flex-row items-center gap-4 w-full">
                    <p-floatlabel variant="on" class="flex-1">
                      <input #repoName type="text" pInputText id="repoName"
                        class="w-full bg-gray-800/50 border-gray-700 text-gray-200 rounded-lg px-4 py-2 focus:outline-none" />
                      <label for="repoName">Study Name</label>
                    </p-floatlabel>
                    <button class="btn btn-sm bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors"
                      (click)="newRepo(repoName.value, 'local', urlInput.value)">
                      Create Study
                    </button>
                  </div>
                </div>
                }@if(repoSelectionState?.state === 'repo_creation_failed'){
                <div class="flex flex-col items-center p-4 bg-red-500/10 rounded-xl border border-red-500/20">
                  <ng-icon name="phosphorXCircle" class="text-2xl text-red-500 mb-2"></ng-icon>
                  <p class="text-center font-medium mb-2 text-red-500">Unable to Create Study</p>
                  <p class="text-center text-gray-400 mb-4">We couldn't create your study. Please check your connection and
                    try again.</p>
                  <!-- <button class="btn btn-sm bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition-colors"
                    (click)="onClose()">Try Again</button> -->
                </div>
                }@if (repoSelectionState?.type === 'local' && repoSelectionState?.state === 'url_invalid'){
                <div class="flex flex-col items-center p-4 bg-red-500/10 rounded-xl border border-gray-700">
                  <ng-icon name="phosphorXCircle" class="text-2xl text-red-500 mb-2"></ng-icon>
                  <p class="text-center font-medium mb-2 text-red-500">The url provided above belongs to a different study</p>
                  <p class="text-center text-gray-400 mb-4">You are connected to the study: <span class="font-bold text-[#8958FE]">{{
                      repo()?.name }}</span></p>
                  <!-- <button class="btn btn-sm bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-lg transition-colors"
                    (click)="onClose()">Open {{ repo()?.name }}</button> -->
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  <div class="bg-white rounded-xl md:rounded-2xl shadow-lg p-4 sm:p-6 md:p-8 mx-auto">
    <div class="border-b border-blue-300 pb-3 md:pb-4 mb-3 md:mb-4">
      <h1 class="text-base sm:text-lg md:text-xl font-semibold text-slate-800">1.2 Select or Upload Protocol</h1>
    </div>
    <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 lg:gap-6">
      <div class="w-full lg:flex-1 space-y-2">
        <p-treeSelect [options]="fileTree" placeholder="Choose Protocol" [appendTo]="'body'"
          [(ngModel)]="usdmSelectedNode">
          <ng-template pTemplate="header">
            <div class="p-2 border-b border-gray-600/30">
              <button type="button"
                class="w-full flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-blue-400 bg-blue-400/10 hover:bg-blue-400/20 hover:text-blue-300 rounded-lg transition-all duration-200 focus:outline-none active:scale-95 cursor-pointer"
                (click)="uploadFile.toggle(rootNode!)">
                <svg class="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                <span>Upload Files</span>
              </button>
            </div>
          </ng-template>
        </p-treeSelect>
      </div>
    </div>
  </div>
  <div class="bg-white rounded-xl md:rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 mx-auto space-y-3 md:space-y-4">
    <div class="border-b border-blue-300 pb-3 md:pb-4 mb-3 md:mb-4">
      <h1 class="text-base sm:text-lg md:text-xl font-semibold text-slate-900">1.3 Addition Information</h1>
    </div>
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4">
      <div class="w-full md:w-1/2 space-y-3 md:space-y-4">
        <p class="block text-xs sm:text-sm font-medium text-slate-800 mb-2">OSB Server URL</p>
        <div>
          <input type="text" placeholder="Enter OSB Server URL" [(ngModel)]="osbServerUrl"
            class="w-full px-3 py-2 text-sm sm:text-base bg-white border border-slate-600 rounded-md focus:outline-none text-slate-800" />
          @if(osbServerUrl === environment.osburl || osbServerUrl === environment.osburl + '/') {
          <p class="text-warning text-sm mt-2">
            Note: This URL will create a public study on our OSB server.
          </p>
          }
        </div>
      </div>
      <div class="w-full md:w-1/2 space-y-3 md:space-y-4 mb-7">
        <p class="block text-xs sm:text-sm font-medium text-slate-800 mb-2">OSB Study ID</p>
        <input type="text" placeholder="Enter OSB Study ID" [(ngModel)]="publicOsbStudyId"
          class="w-full px-3 py-2 text-sm sm:text-base bg-white border border-slate-600 rounded-md focus:outline-none text-slate-800" />
      </div>
    </div>
  </div>
  <div class="flex justify-center mx-auto">
    <button (click)="onSubmit()"
      class="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-gray-400 disabled:transform-none text-white font-medium py-2 sm:py-3 px-10 text-sm sm:text-base rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer">
      Submit
    </button>
  </div>
</div>
<app-upload-file #uploadFile [singleFileMode]="true" (fileUploaded)="onFileUpload($event)"></app-upload-file>
